import React, { SyntheticEvent } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
require('react-datepicker/dist/react-datepicker.css');

function DatePickerComponent(props: IDatePicker) {
    const [startDate, setStartDate] = React.useState(props.selected ? new Date(props.selected) : null);

    return (
        <div
            style={{
                display: 'inline-flex',
                margin: '5px 0px 5px 0px',
            }}
        >
            {props.name && (
                <div
                    style={{
                        margin: '7px 0px 0px 0px',
                        fontSize: '14px',
                    }}
                >
                    {props.name}
                </div>
            )}
            <DatePickerTag width={props.width}>
                <DatePicker
                    selected={startDate}
                    onChange={(e) => {
                        if (e) {
                            setStartDate(new Date(e.toString()));
                        }
                        props.onChange && props.onChange(e, props.eventReturn);
                    }}
                    dateFormat="yyyy-MM-dd"
                />
            </DatePickerTag>
        </div>
    );
    // return (
    //     <DatePickerTag>
    //         <DatePicker selected={startDate} onChange={(e) => props.onChange} dateFormat="yyyy-MM-dd hh:mm:ss" />
    //     </DatePickerTag>
    // );
}

export default React.memo(DatePickerComponent);

interface IDatePicker {
    /**
     * 네임
     */
    name: string;

    /**
     * 너비 ( : 100%)
     */
    width?: 'small' | 'medium' | 'large' | 'full';

    /**
     * 날짜 변경 이벤트
     */
    onChange?: (any: any, eventReturn: any) => void;

    /**
     * 선택일 기본값
     */
    selected: string | number | Date;

    /**
     * 변수명
     */
    eventReturn: any;
}

interface IDatePickerTag extends Pick<IDatePicker, 'width'> {}
const DatePickerTag = styled.div<IDatePickerTag>`
    ${({ theme, width }) => {
        const useWidth = width
            ? typeof width === 'number'
                ? `${width}px`
                : Object.keys(theme.defaultSize.large).includes(width)
                ? `${(theme.defaultSize as any)[width]}`
                : `92px`
            : `92px`;
        return `
    width: ${useWidth};
    flex-shrink: ${useWidth === '100%' ? 'auto' : '0'};
    `;
    }}

    height: ${({ theme }) => theme.defaultHeight}px;
    margin: 3px 4px;

    > div:nth-child(2) {
        position: absolute;
        left: 807px;
    }
    > div {
        position: relative;
        width: 100%;
        height: 100%;

        > div {
            width: 100%;
            height: 100%;
            > input {
                width: 100%;
                height: 100%;
                cursor: pointer;

                padding: 0 10px 0 10px;
                border: 1px solid ${({ theme }) => theme.color.borderDefault};
                border-radius: 4px;

                &:disabled {
                    background-color: ${({ theme }) => theme.color.fontDisable};
                    color: ${({ theme }) => theme.color.fontDisable};
                }

                outline: none;
                &:focus {
                    border-color: #555;
                }
            }
        }
    }
`;
